// extracted by mini-css-extract-plugin
export default {"form":"SearchInput_form__adHca","icon":"SearchInput_icon__ZC9k8","input":"SearchInput_input__4b-9Q","close":"SearchInput_close__qGzGm","creatoricon":"SearchInput_creatoricon__mat7p"};